import { connect } from "react-redux";
import { setDisableAutomatedSendModalOpen, setConnectedService } from "../../Header/actions/creators";
import DisableAutomatedSendModal from "./DisableAutomatedSendModal";

const mapStateToProps = (state) => ({
  show: state.tdpDetailsReducer.isDisableAutomatedSendModalOpen,
  listingUuid: state.tdpDetailsReducer.uuid,
});

const mapDispatchToProps = (dispatch) => ({
  onClose: () => dispatch(setDisableAutomatedSendModalOpen(false)),
  setConnectedService: (connectedService) => dispatch(setConnectedService(connectedService)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DisableAutomatedSendModal);
